import styles from "../Collapse/collapse.module.scss";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Collapse = ({
  title,
  content,
  logo,
  logo2,
  altLogo,
  isOpen,
  onToggle,
}) => {
  let contents = "";
  if (Array.isArray(content)) {
    contents = (
      <ul>
        {content.map((content, index) => (
          <li key={index}>{content}</li>
        ))}
      </ul>
    );
  } else {
    contents = <p id="collapse_content">{content}</p>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.sectionCollapse}>
        <button onClick={onToggle} className={styles.collapseButton}>
          <span className="progressText">
            {title}
            <img className="skillImg" src={logo} alt={`îcone ${title}`} />
            {logo2 && <img className="skillImg" src={logo2} alt={altLogo} />}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`${styles.icon} ${isOpen ? styles.rotate : ""}`}
          />
        </button>

        <div className={`${styles.content} ${isOpen ? styles.active : ""}`}>
          <div
            className={`${styles.contentCollapse} ${
              isOpen ? styles.active : ""
            }`}
          >
            {contents}
          </div>
        </div>
      </div>
    </div>
  );
};

Collapse.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  logo2: PropTypes.string,
};

export default Collapse;
